module.exports = __webpack_public_path__ + "static/bottle-shadow-7c29c632651b6f8fbce4d8274c130b70.png";